// src/components/doctor/PrescriptionPrint.jsx
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { markPrescriptionPrinted } from "../../Redux/actions/doctorActions/doctorActions";
import QRCode from "qrcode";

const PrescriptionPrint = ({ medicalRecord, appointment, onClose }) => {
  const dispatch = useDispatch();

  const handlePrint = async () => {
    try {
      // Generate QR code
      const qrText = `https://shoaibhospital.cloud/prescription/${medicalRecord._id}`;
      const qrDataUrl = await QRCode.toDataURL(qrText, {
        errorCorrectionLevel: "H",
        width: 120,
      });

      const printedAt = new Date().toLocaleString();

      const html = `
      <html>
      <head>
        <title>Medical Prescription</title>
        <style>
          * { margin: 0; padding: 0; box-sizing: border-box; }
          body {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            padding: 15px;
            background: white;
            font-size: 11px;
          }
          .prescription-container {
            max-width: 850px;
            margin: 0 auto;
            border: 2px solid #333;
            padding: 0;
          }
          .header {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            padding: 12px 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          .header-left h1 {
            margin: 0 0 3px 0;
            font-size: 24px;
          }
          .header-left p {
            margin: 0;
            font-size: 10px;
            opacity: 0.95;
            line-height: 1.3;
          }
          .header-right {
            text-align: right;
            font-size: 10px;
            line-height: 1.4;
          }
          .header-right strong {
            font-size: 11px;
          }
          .content {
            padding: 15px 20px;
          }
          .section {
            margin-bottom: 12px;
            padding-bottom: 8px;
            border-bottom: 1px solid #e0e0e0;
          }
          .section:last-child {
            border-bottom: none;
          }
          .section-title {
            font-size: 12px;
            font-weight: bold;
            color: #667eea;
            margin-bottom: 6px;
            text-transform: uppercase;
          }
          .patient-info {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 8px;
            margin-bottom: 8px;
          }
          .info-item {
            font-size: 11px;
          }
          .info-label {
            font-weight: 600;
            color: #555;
          }
          .info-value {
            color: #000;
          }
          .vitals-line {
            font-size: 11px;
            padding: 6px 10px;
            background: #f8f9fa;
            border-radius: 4px;
            display: flex;
            gap: 15px;
            flex-wrap: wrap;
          }
          .vitals-line span {
            white-space: nowrap;
          }
          .clinical-compact {
            font-size: 11px;
            line-height: 1.4;
          }
          .clinical-compact > div {
            margin-bottom: 4px;
          }
          .rx-symbol {
            font-size: 28px;
            color: #667eea;
            font-weight: bold;
            font-family: 'Times New Roman', serif;
            margin: 8px 0 4px 0;
          }
          .medicine-table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 6px;
            font-size: 10px;
          }
          .medicine-table th {
            background: #f5f5f5;
            padding: 5px;
            text-align: left;
            border: 1px solid #ddd;
            font-size: 10px;
          }
          .medicine-table td {
            padding: 4px 5px;
            border: 1px solid #ddd;
            font-size: 10px;
          }
          .lab-tests-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 6px;
            margin-top: 6px;
          }
          .lab-test-item {
            padding: 5px 8px;
            background: #f8f9fa;
            border-radius: 3px;
            font-size: 10px;
          }
          .urgent-badge {
            background: #dc3545;
            color: white;
            padding: 1px 4px;
            border-radius: 2px;
            font-size: 9px;
            margin-left: 4px;
          }
          .footer-section {
            margin-top: 15px;
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
          }
          .doctor-signature {
            text-align: right;
          }
          .signature-line {
            border-top: 1px solid #000;
            margin-top: 30px;
            padding-top: 4px;
            min-width: 180px;
            font-size: 10px;
          }
          .qr-section {
            text-align: center;
          }
          .qr-section img {
            width: 80px;
            height: 80px;
          }
          .print-info {
            text-align: center;
            font-size: 9px;
            color: #666;
            margin-top: 10px;
            padding-top: 8px;
            border-top: 1px dashed #ccc;
          }
          @media print {
            @page { 
              size: legal;
              margin: 10mm;
            }
            body { 
              padding: 0;
              font-size: 10px;
            }
            .prescription-container { 
              border: 1px solid #333;
            }
            .section {
              margin-bottom: 8px;
              padding-bottom: 6px;
            }
          }
        </style>
      </head>
      <body>
        <div class="prescription-container">
          <!-- Header -->
          <div class="header">
            <div class="header-left">
              <h1>🏥 Zainab Medical & Children Care Centre </h1>
              <p>Contact: +923152189910 (Whatsapp Only) / +923153051011 | Web: www.shoaibhospital.cloud</p>
              <p>Address: Gt Road, Darwaish, Near New Bus Stand, Haripur</p>
            </div>
            <div class="header-right">
              <strong>Dr. ${medicalRecord.doctorId?.name}</strong><br/>
              ${medicalRecord.doctorId?.specialization}<br/>
              ${medicalRecord.doctorId?.department}
              ${medicalRecord.doctorId?.contact ? `<br/>${medicalRecord.doctorId.contact}` : ''}
            </div>
          </div>

          <div class="content">
            <!-- Patient Info -->
            <div class="patient-info">
              <div class="info-item">
                <span class="info-label">Patient:</span>
                <span class="info-value">${appointment.pName}</span>
              </div>
              <div class="info-item">
                <span class="info-label">MR Code:</span>
                <span class="info-value"><code>${medicalRecord.mrCode}</code></span>
              </div>
              <div class="info-item">
                <span class="info-label">Age:</span>
                <span class="info-value">${appointment.age || 'N/A'}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Date:</span>
                <span class="info-value">${appointment.date}</span>
              </div>
            </div>

            <!-- Vitals in One Line -->
            ${medicalRecord.vitals && (medicalRecord.vitals.bp || medicalRecord.vitals.weight) ? `
            <div class="vitals-line">
              ${medicalRecord.vitals.bp ? `<span><strong>BP:</strong> ${medicalRecord.vitals.bp}</span>` : ''}
              ${medicalRecord.vitals.weight ? `<span><strong>Weight:</strong> ${medicalRecord.vitals.weight} kg</span>` : ''}
              ${medicalRecord.vitals.spo2 ? `<span><strong>SPO2:</strong> ${medicalRecord.vitals.spo2}%</span>` : ''}
              ${medicalRecord.vitals.temperature ? `<span><strong>Temp:</strong> ${medicalRecord.vitals.temperature}°F</span>` : ''}
              ${medicalRecord.vitals.height ? `<span><strong>Height:</strong> ${medicalRecord.vitals.height} cm</span>` : ''}
              ${medicalRecord.vitals.bmi ? `<span><strong>BMI:</strong> ${medicalRecord.vitals.bmi}</span>` : ''}
            </div>` : ''}

            <!-- Clinical Findings Compact -->
            <div class="section">
              <div class="section-title">Clinical Findings</div>
              <div class="clinical-compact">
                <div><span class="info-label">Complaint:</span> ${medicalRecord.chiefComplaint}</div>
                ${medicalRecord.symptoms ? `<div><span class="info-label">HOPC:</span> ${medicalRecord.symptoms}</div>` : ''}
                ${medicalRecord.physicalExamination ? `<div><span class="info-label">Examination:</span> ${medicalRecord.physicalExamination}</div>` : ''}
                <div><span class="info-label">Diagnosis:</span> <strong>${medicalRecord.diagnosis}</strong></div>
                ${medicalRecord.clinicalNotes ? `<div><span class="info-label">Notes:</span> ${medicalRecord.clinicalNotes}</div>` : ''}
              </div>
            </div>

            <!-- Prescription -->
            ${medicalRecord.medicines && medicalRecord.medicines.length > 0 ? `
            <div class="section">
              <div class="rx-symbol">℞</div>
              <table class="medicine-table">
                <thead>
                  <tr>
                    <th style="width: 3%;">#</th>
                    <th style="width: 25%;">Medicine</th>
                    <th style="width: 11%;">Route</th>
                    <th style="width: 11%;">Dosage</th>
                    <th style="width: 10%;">Frequency</th>
                    <th style="width: 12%;">Duration</th>
                    <th style="width: 28%;">Instructions</th>
                  </tr>
                </thead>
                <tbody>
                  ${medicalRecord.medicines.map((med, idx) => `
                    <tr>
                      <td>${idx + 1}</td>
                      <td><strong>${med.medicineName}</strong></td>
                      <td>${med.route || '-'}</td>
                      <td>${med.dosage}</td>
                      <td>${med.frequency}</td>
                      <td>${med.duration}</td>
                      <td>${med.instructions || '-'}</td>
                    </tr>
                  `).join('')}
                </tbody>
              </table>
            </div>` : ''}

            <!-- Lab Tests in Grid -->
            ${medicalRecord.labTests && medicalRecord.labTests.length > 0 ? `
            <div class="section">
              <div class="section-title">Lab Tests</div>
              <div class="lab-tests-grid">
                ${medicalRecord.labTests.map((test, idx) => `
                  <div class="lab-test-item">
                    <strong>${idx + 1}. ${test.testName}</strong>
                    ${test.urgent ? '<span class="urgent-badge">URGENT</span>' : ''}
                    ${test.resultRemarks ? `<br/><small style="color: #666; font-size: 9px;">${test.resultRemarks}</small>` : ''}
                  </div>
                `).join('')}
              </div>
            </div>` : ''}

            <!-- Referral -->
            ${medicalRecord.referral?.isReferred ? `
            <div class="section">
              <div class="section-title">Referral</div>
              <div style="font-size: 11px;">
                <strong>Dr. ${medicalRecord.referral.referredTo?.name}</strong> (${medicalRecord.referral.referredTo?.specialization}) - ${medicalRecord.referral.referredTo?.department}
                <br/><span class="info-label">Reason:</span> ${medicalRecord.referral.reason}
              </div>
            </div>` : ''}

            <!-- Follow-up -->
            ${medicalRecord.followUpDate ? `
            <div class="section">
              <div class="section-title">Follow-up</div>
              <div style="font-size: 11px;">
                <span class="info-label">Next Visit:</span> ${new Date(medicalRecord.followUpDate).toLocaleDateString()}
                ${medicalRecord.followUpNotes ? ` | ${medicalRecord.followUpNotes}` : ''}
              </div>
            </div>` : ''}

            <!-- Footer with Signature and QR -->
            <div class="footer-section">
              <div class="qr-section">
                <img src="${qrDataUrl}" alt="QR Code" />
                <p style="font-size: 9px; margin-top: 3px;">Scan to verify</p>
              </div>
              <div class="doctor-signature">
                <div class="signature-line">
                  <strong>Dr. ${medicalRecord.doctorId?.name}</strong><br/>
                  ${medicalRecord.doctorId?.specialization}
                </div>
              </div>
            </div>

            <div class="print-info">
              <p>Printed: ${printedAt} | This is a computer-generated prescription | ⚕️ Your Health, Our Priority</p>
              <p style="margin-top: 4px; font-size: 8px;">Computer software developed by Bilal Consultancy - Ph: +923152311183</p>
            </div>
          </div>
        </div>

        <script>
          window.onload = () => {
            window.print();
          };
        </script>
      </body>
      </html>
      `;

      const printWindow = window.open("", "_blank", "width=900,height=1000");
      if (!printWindow) {
        alert("Please allow popups to print prescriptions");
        return;
      }

      printWindow.document.write(html);
      printWindow.document.close();

      // Mark as printed
      dispatch(markPrescriptionPrinted(medicalRecord._id));
    } catch (error) {
      console.error("Print error:", error);
      alert("Failed to print prescription");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container modal-lg">
        <div className="modal-header-custom">
          <h4>
            <i className="bi bi-printer me-2"></i>
            Prescription Created Successfully
          </h4>
          <button className="btn-close-custom" onClick={onClose}>
            <i className="bi bi-x-lg">Close</i>
          </button>
        </div>

        <div className="modal-body-custom text-center py-5">
          <div className="success-icon mb-3">
            <i className="bi bi-check-circle-fill text-success" style={{ fontSize: "72px" }}></i>
          </div>
          <h5 className="mb-3">Medical record saved successfully!</h5>
          <p className="text-muted mb-4">
            The prescription is ready to print. Click the button below to print.
          </p>

          <button className="btn btn-primary btn-lg me-2" onClick={handlePrint}>
            <i className="bi bi-printer me-2"></i>
            Print Prescription
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrescriptionPrint;